export const unknownString = 'unknown';
//# sourceMappingURL=const.js.map